var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"spinner"}),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.loadingText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }